
























































































import {Component} from "vue-property-decorator";
import {Hamburger} from "../../../../components";
import {AppModule} from "@/store/modules/app";
import {DeviceType} from "@/enums/type";
import {AuthStore} from "@/modules/auth/store";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import AInputBarCode from "@/shared/components/InputBarCode/index.vue";
import Checking from "@/modules/checking/index.vue";
import {getChecking, getTracking} from "@/modules/checking/services";
import {NotificationParams, NotificationReadStatus} from "@/modules/account";

@Component({
  name: 'Navbar',
  components: {Checking, AInputBarCode, Hamburger}
})
export default class extends mixins(CommonMixin) {
  deviceType = DeviceType;
  ladingCode = "";
  checkings = [] as any;
  visibleModal = false;
  NotificationReadStatus = NotificationReadStatus;
  backgroundColor = {
    readed: '#d2d2d2',
    notYet: '#d40404'
  }

  created() {
    AuthStore.countNotification();
    AuthStore.getListNotification({...new NotificationParams(), limit: 5});
  }

  get sidebar() {
    return AppModule.sidebar;
  }

  get device() {
    return AppModule.device;
  }

  get user() {
    return AuthStore.user;
  }

  get quantityNotification() {
    return AuthStore.quantityNotify;
  }

  get listNotification() {
    return AuthStore.listNotification;
  }

  toggleSidebar() {
    AppModule.ToggleSidebar();
  }

  logout() {
    AuthStore.logout();
  }

  closeModal() {
    this.visibleModal = false;
    this.ladingCode = "";
  }

  async onEnterLadingCode(evt: any) {
    const trackingDatas = ''
    const ladingCode = evt?.target?.value;
    if (!ladingCode) return;
    try {
      const {data} = await getChecking(ladingCode);
      // await getTracking(ladingCode).then(response => response.json()).then(data => {
      //   for (const i in data.datas) {
      //     data.datas[i].createdDate = new Date(data.datas[i].ladingDate).toLocaleTimeString('vi-vn', {
      //       hour: '2-digit',
      //       minute: '2-digit'
      //     }) + ' ' + new Date(data.datas[i].ladingDate).toLocaleDateString('vi-vn', {
      //       day: '2-digit',
      //       month: '2-digit',
      //       year: 'numeric'
      //     });
      //     data.datas[i].updatedDate = new Date(data.datas[i].ladingDate).toLocaleTimeString('vi-vn', {
      //       hour: '2-digit',
      //       minute: '2-digit'
      //     }) + ' ' + new Date(data.datas[i].ladingDate).toLocaleDateString('vi-vn', {
      //       day: '2-digit',
      //       month: '2-digit',
      //       year: 'numeric'
      //     });
      //   }
      //   trackingDatas = data.datas
      // }).catch((error) => {
      //   console.error(error);
      // });
      if (!trackingDatas) {
        this.checkings = data.datas;
      } else {
        this.checkings = data.datas.concat(trackingDatas);
      }
      this.visibleModal = true;
    } catch (e) {
      this.$message.error(e?.response?.data?.message || "Checking thất bại");
    }
  }
}
